module.exports = __webpack_public_path__ + "img/641.8f583b7d.png";